"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationController = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const react_1 = __importStar(require("react"));
const NotificationType_1 = __importDefault(require("../NotificationType"));
const NotificationContext_1 = __importDefault(require("../useNotification/NotificationContext"));
const NotificationActionsContext_1 = __importDefault(require("../useNotificationActions/NotificationActionsContext"));
function NotificationController({ children }) {
    const [ctxChanged, setCtxChanged] = (0, react_1.useState)();
    const notification = (0, react_1.useRef)();
    const clearNotifications = (0, react_1.useCallback)(() => {
        notification.current = undefined;
        setCtxChanged(new Date());
    }, []);
    const raiseNotification = (0, react_1.useCallback)((level, value, okLabel, okColor, onOk, cancelLabel, cancelColor, onCancel) => {
        let message;
        if (value === null || value === void 0 ? void 0 : value.message) {
            message = value.message;
        }
        else if (typeof value === 'string') {
            message = value;
        }
        else {
            message = lib_i18n_1.default.t('error-unexpected-problem');
        }
        notification.current = {
            message,
            level,
            okLabel,
            okColor,
            onOk,
            cancelLabel,
            cancelColor,
            onCancel,
        };
        setCtxChanged(new Date());
    }, []);
    const raiseInfo = (0, react_1.useCallback)(message => {
        raiseNotification(NotificationType_1.default.INFO, message);
    }, [raiseNotification]);
    const raiseSuccess = (0, react_1.useCallback)(message => {
        raiseNotification(NotificationType_1.default.SUCCESS, message);
    }, [raiseNotification]);
    const raiseOkCancel = (0, react_1.useCallback)((message, options) => {
        const { okLabel = lib_i18n_1.default.t('ok'), okColor = lib_palette_1.default.GoodGreen, onOk, cancelLabel = lib_i18n_1.default.t('cancel'), cancelColor = lib_palette_1.default.LavendarGrey, onCancel, } = options;
        raiseNotification(NotificationType_1.default.OK_CANCEL, message, okLabel, okColor, onOk, cancelLabel, cancelColor, onCancel);
    }, [raiseNotification]);
    const raiseError = (0, react_1.useCallback)(message => {
        raiseNotification(NotificationType_1.default.ERROR, message);
    }, [raiseNotification]);
    const raiseWarning = (0, react_1.useCallback)(message => {
        raiseNotification(NotificationType_1.default.WARNING, message);
    }, [raiseNotification]);
    const raise = (0, react_1.useCallback)((p, successMessage, failMessage, duringMessage) => __awaiter(this, void 0, void 0, function* () {
        if (duringMessage) {
            raiseInfo(duringMessage);
        }
        return p
            .then(v => {
            if (successMessage)
                raiseSuccess(successMessage);
            return v;
        })
            .catch(e => {
            if (failMessage) {
                raiseError(failMessage);
            }
            else if (e.message) {
                raiseError(e.message.split('GraphQL error: ').join(''));
            }
            raiseError(lib_i18n_1.default.t('unexpected-problem'));
            throw new Error(failMessage);
        });
    }), [raiseError, raiseInfo, raiseSuccess]);
    const actionsCtx = (0, react_1.useMemo)(() => ({
        raise,
        raiseError,
        raiseWarning,
        raiseInfo,
        raiseSuccess,
        raiseOkCancel,
        clearNotifications,
    }), [
        clearNotifications,
        raise,
        raiseOkCancel,
        raiseError,
        raiseInfo,
        raiseSuccess,
        raiseWarning,
    ]);
    const ctx = (0, react_1.useMemo)(() => notification.current, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ctxChanged]);
    return (react_1.default.createElement(NotificationActionsContext_1.default.Provider, { value: actionsCtx },
        react_1.default.createElement(NotificationContext_1.default.Provider, { value: ctx }, children)));
}
exports.NotificationController = NotificationController;
exports.default = NotificationController;
